import { AppData } from "@lightningjs/sdk";
import { utils } from "@lightningjs/ui-components";
import { AppSetup } from "../../../app-setup";
import { Helper } from "../../../helper";



export const base = theme => ({
  //w: utils.getWidthByUpCount(theme, 8),
  titleMarginLeft: -12,
  titleMarginTop: 8,
  titleMarginBottom: 8,
  titleTextStyle: {
    //...theme.typography.headline1,
    textColor: theme.color.textNeutral,
    fontFace: Helper.getFontFamily('Black'),
    fontSize: 30,
  },
  itemSpacing : 15,
  itemTransition : ()=>{
     const {appConfig} = AppData as AppSetup
     if(appConfig?.enableGridAnimation) {
        return {
            timingFunction:'linear',
            duration: 0.3, //300 ms
            delay: 0
          }
     } else {
        return {
            timingFunction:'step-end',
            duration: 0.005, //300 ms
            delay: 0
          }
     }
  }
});

export const tone = theme => ({
  neutral: {
    titleTextStyle: { textColor: theme.color.textNeutral }
  },
  inverse: {
    titleTextStyle: { textColor: theme.color.textInverse }
  },
  brand: {
    titleTextStyle: { textColor: theme.color.textNeutral }
  }
});
